import {t} from '../../../common/getTranslations';
import {VIEWER_SETTING_FONT_TYPE_TO_COPY_MAP_FOR_LOGGING} from '../../../domain/content/[seriesId]/viewer/[productId]/constant/viewerConstant';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {fontItems} from './constant';
import {ViewerSettingFontFamilyProps} from './ViewerSettingFontFamilyProps.interface';
import {ViewerSettingScrollableItem} from './ViewerSettingScrollableItem';

export function ViewerSettingFontFamily({
  isMobile,
  currentFontType,
  onClickFontFamily,
}: ViewerSettingFontFamilyProps) {
  return (
    <ViewerSettingScrollableItem
      isMobile={isMobile}
      title={t('viewer_setting_font')}
      gapPx={14}
      className={isMobile ? 'mt-6pxr' : 'mt-10pxr'}
    >
      {fontItems.map(fontItem => {
        const isSelected = fontItem.font === currentFontType;
        return (
          <Icon
            key={fontItem.font}
            type={isSelected ? fontItem.onIconType : fontItem.offIconType}
            className="cursor-pointer"
            {...putTiaraObjectProps({
              click: {
                layer1: '뷰어설정',
                copy: VIEWER_SETTING_FONT_TYPE_TO_COPY_MAP_FOR_LOGGING[
                  fontItem.font
                ],
              },
            })}
            onClick={e =>
              LOG_CLICK_EVENT('글꼴_클릭', e, () => {
                onClickFontFamily(fontItem.font);
              })
            }
          />
        );
      })}
    </ViewerSettingScrollableItem>
  );
}
